/**
 * Map support API calls to human-readable feature titles for Live Tracking.
 * Title format: "{Feature name} error" — e.g. "Take a break error"
 */

function asBody(requestData) {
    if (!requestData || typeof requestData !== 'object') return {};
    return requestData;
}

function hasValue(values, key) {
    return Array.isArray(values) && values.includes(key);
}

/** @returns {string|null} e.g. "Take a break error" */
export function deriveSupportFeatureTitle(endpoint, requestData) {
    const path = String(endpoint || '').split('?')[0];
    const lowerPath = path.toLowerCase();
    const body = asBody(requestData);
    const values = body.values;

    if (/\/userauth\/resetdoorpin\b/i.test(path)) return 'Door PIN error';
    if (/\/parentapp\/createticket\b/i.test(path)) return 'Contact us error';
    if (/\/parentapp\/sendfeecertificate\b/i.test(path)) return 'Fee certificate error';
    if (/\/financials\/savenonsatisfactionrefund/i.test(lowerPath)) return 'Non satisfaction error';
    if (/\/financials\/gettuitionfeecertificate/i.test(lowerPath)) return 'Fee certificate error';
    if (/\/financials\//i.test(path)) return 'Finance error';
    if (/\/chargebees\//i.test(path)) return 'Finance error';
    if (/\/franchises\/resumechild/i.test(lowerPath)) return 'Early resume error';
    if (/\/franchises\/pausechild/i.test(lowerPath)) return 'Extend pause error';

    if (!/\/parentapp\/request\b/i.test(path)) return null;

    if (body.child_pause === 'yes' || hasValue(values, 'child_pause')) {
        return 'Take a break error';
    }
    if (body.extended_daycare === 'yes' || hasValue(values, 'extended_daycare')) {
        return 'Extended daycare error';
    }
    if (
        body.one_way_transport != null ||
        body.two_way_transport != null ||
        hasValue(values, 'one_way_transport') ||
        hasValue(values, 'two_way_transport')
    ) {
        return 'Transport error';
    }
    if (body.child_attrition === 'yes' || hasValue(values, 'child_attrition')) {
        return 'Withdraw child error';
    }
    if (body.program_change === 'yes' && body.center_shift !== 'yes') {
        return 'Change program error';
    }
    if (body.center_shift === 'yes') {
        return 'Shift center error';
    }

    return 'Support request error';
}

export function parseAxiosRequestData(config) {
    const data = config?.data;
    if (!data) return null;
    if (typeof data === 'object') return data;
    if (typeof data === 'string') {
        try {
            return JSON.parse(data);
        } catch {
            return null;
        }
    }
    return null;
}
